/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.AddressType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.AddressType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum AddressType_ {
   /// <summary>
   ///   Shipping Address (S)
   /// </summary>
   Shipping = 1,
   /// <summary>
   ///   Billing Address (B)
   /// </summary>
   Billing = 2,
   /// <summary>
   ///   Shipping/Billing (Same) Address (S/B)
   /// </summary>
   ShippingBillingSame = 3
}

export const AddressTypes: AddressType[] = [
   {
      code: AddressType_.Shipping,
      literal: 'Shipping',
      description: 'Shipping Address',
      shortDescription: 'S',
      listPriority: 0,

      typeName: "AddressType"
   },
   {
      code: AddressType_.Billing,
      literal: 'Billing',
      description: 'Billing Address',
      shortDescription: 'B',
      listPriority: 0,

      typeName: "AddressType"
   },
   {
      code: AddressType_.ShippingBillingSame,
      literal: 'ShippingBillingSame',
      description: 'Shipping/Billing (Same) Address',
      shortDescription: 'S/B',
      listPriority: 0,

      typeName: "AddressType"
   }
]

export class AddressType implements IDomainModel {
   code: AddressType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: AddressType_): AddressType {
      return AddressTypes.find(d => d.code === code)
   }
}
